import { PageHeader } from "components";
import { Entry } from "contentful";
import { NextPage } from "next";
import {
  DeliverySection,
  NewsHeaderSection,
  NewsletterSection,
  NewsSection,
} from "sections";
import {
  IArticleV3Fields,
  IDeliverySectionFields,
  INews,
  IStaticNewsletterSectionFields,
} from "types";
import {
  fetchHeaderArticle,
  fetchNewsArticles,
  getContentfulEntries,
  toNewsListItem,
} from "utils/contentful-api";

const News: NextPage<{
  news: INews[];
  headerArticle: INews[];
  newsletter: IStaticNewsletterSectionFields[];
  delivery: IDeliverySectionFields[];
}> = ({ news, headerArticle, newsletter, delivery }) => {
  return (
    <div>
      <PageHeader title="News" />
      <NewsHeaderSection articles={headerArticle} />
      <NewsSection news={news} />
      <DeliverySection deliverySection={delivery} />
      <NewsletterSection newsletterSection={newsletter} />
    </div>
  );
};
export default News;

export async function getStaticProps() {
  const articlesRes = await fetchNewsArticles();
  const news = (articlesRes ?? []).map((p: Entry<IArticleV3Fields>) =>
    toNewsListItem(p.fields)
  );

  const headerArticleRes = await fetchHeaderArticle();
  const headerArticle = (headerArticleRes ?? []).map(
    (p: Entry<IArticleV3Fields>) => toNewsListItem(p.fields)
  );

  const delivery = await getContentfulEntries<IDeliverySectionFields>(
    "deliverySection"
  );

  const newsletter = await getContentfulEntries<IStaticNewsletterSectionFields>(
    "newsletterSection"
  );

  return {
    props: {
      news,
      headerArticle,
      newsletter,
      delivery,
    },
    revalidate: 3600, // Revalidate every hour
  };
}
